<template>
  <b-card>
    <h3>{{$t('MY_ACCOUNT.Shortcut_Title')}}</h3>
    <!-- form -->
    <b-form class="form-user">
    
      <b-row>
        <b-col cols="12">
          <b-form-group :label="$t('MY_ACCOUNT.Shortcut_Signature')" label-for="signature-list">
           <v-select
              id="signature-list"
              v-model="form.signatures"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              multiple
              taggable
              push-tags
            >
              <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group :label="$t('MY_ACCOUNT.Shortcut_UserHeader')" label-for="userheader-list">
            <v-select
              id="userheader-list"
              label="name"
              :options="userHeader"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="form.user_header"
              multiple
            >
              <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
            </v-select>
          </b-form-group>
        </b-col>
         <b-col sm="12">
          <b-form-group :label="$t('MY_ACCOUNT.Shortcut_Footer')" label-for="content-footer">
            <b-form-input
              v-model="form.contentFooter"
              name="content-footer"
              :placeholder="$t('MY_ACCOUNT.Shortcut_Footer')"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            size="sm"
            @click="onSubmit"
          >
            {{$t('MY_ACCOUNT.Save')}}
          </b-button>
          <!-- <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            type="reset"
            class="mt-2"
            @click.prevent="resetForm"
          >
            Reset
          </b-button> -->
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  // BBadge,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ref } from "@vue/composition-api";
import vSelect from "vue-select";
import dropdownService from "@/providers/dropdownService";
import userService from "@/providers/userService";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
import localStorageHelper from '@/helpers/local-storage-helper';

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    vSelect,
    // BBadge,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      // optionsLocal: JSON.parse(JSON.stringify(this.generalData)),
      userHeader: [],
      form: {
        _id: "",
        signatures: [],
        user_header: [],
        contentFooter: ""
      },
    };
  },
  created() {
    this.loadData();
  },
  watch: {
  },
  methods: {
    onSubmit() {
      userService
        .updateMyAccountShortcuts(this.form, new URLSearchParams())
        .then((data) => {
          console.log(data);
          messagesNotifyHelper.updatedRecordNotify();
        })
        .catch((err) => console.log(err));
    },
    loadData() {
      Promise.all([
        dropdownService.getAllHeader(new URLSearchParams()),
      ])
        .then((res) => {
          this.userHeader = res[0];
          this.getUserDetail();
        })
        .catch((err) => console.log(err));
    },
    getUserDetail() {
      const params = new URLSearchParams();
      // console.log('state current user: ',this.$store.state.auth.currentUser)
      // params.append("email", this.$store.state.auth.currentUser.email);
      userService
        .getUserDetails(localStorageHelper.getUserId(), params)
        .then((res) => {
          // console.log(res);
          this.form._id = res._id;
          this.form.signatures = res.signatures;
          this.form.user_header = res.user_header;
          this.form.contentFooter = res.contentFooter;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    resetForm() {
      // this.optionsLocal = JSON.parse(JSON.stringify(this.generalData));
    },
  },
  setup() {
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, previewEl);

    return {
      refInputEl,
      previewEl,
      inputImageRenderer,
    };
  },
};
</script>
